import type { Directory, NavigationItem } from '../types';

const createNavigationItem = (
    name: string,
    link: string,
    hideForGuest = false,
): NavigationItem => {
    return {
        id: name,
        name,
        link,
        hideForGuest,
    };
};

const createMegaMenuNavList = (
    name: string,
    children?: NavigationItem[],
): NavigationItem => {
    return {
        id: name,
        name,
        link: '',
        children,
    };
};

export const MAJOR_NAVIGATION_CONFIGURATION_SERVER: Record<
    Directory,
    {
        prettyTitle?: string;
        featuredList?: NavigationItem;
        exploreList?: NavigationItem;
    }
> = {
    product: {
        prettyTitle: 'Categories',
        featuredList: createMegaMenuNavList('Featured', [
            createNavigationItem('Top Products', '/products'),
            createNavigationItem('New Products', '/products/sort_new'),
            createNavigationItem(
                'Trending Products',
                '/products/sort_trending',
            ),
        ]),
        exploreList: createMegaMenuNavList('Explore', [
            createNavigationItem('Shop online', '/products?forSale=1'),
            createNavigationItem(
                'Products on sale (discount)',
                '/products?isOnSale=1',
            ),
            createNavigationItem(
                'Product samples',
                '/products?isSampleAvailable=1',
            ),
        ]),
    },
    project: {
        prettyTitle: 'Categories',
        featuredList: createMegaMenuNavList('Featured', [
            createNavigationItem('Top Projects', '/projects'),
            createNavigationItem('New Projects', '/projects/sort_new'),
            createNavigationItem(
                'Trending Projects',
                '/projects/sort_trending',
            ),
        ]),
        exploreList: createMegaMenuNavList('Explore', [
            createNavigationItem(
                'Project of the month',
                '/projects/sort_new?projectOfTheMonth=1',
            ),
            createNavigationItem(
                'Award winning Projects',
                '/projects?hasAwards=1',
            ),
            createNavigationItem(
                'Projects with videos',
                '/projects?hasVideos=1',
            ),
        ]),
    },
    professional: {
        prettyTitle: 'Categories',
        featuredList: createMegaMenuNavList('Featured', [
            createNavigationItem('Top Professionals', '/professionals'),
            createNavigationItem(
                'New Professionals',
                '/professionals/sort_new',
            ),
            createNavigationItem(
                'Trending Professionals',
                '/professionals/sort_trending',
            ),
        ]),
        exploreList: createMegaMenuNavList('Explore', [
            createNavigationItem(
                'Award winning Professionals',
                '/professionals?hasAwards=1',
            ),
            createNavigationItem(
                'Professionals in my region',
                '/professionals?currentLocation=1',
            ),
        ]),
    },
    article: {
        prettyTitle: 'Categories',
    },
};
